// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Route, Routes } from 'react-router-dom';
import { useCredentialEntries } from '../hooks/other/useCredentialEntries';
import { CommonUtilitiesLayout } from '../layout/CommonUtilitiesLayout';

export const Credential: React.FC = () => {
  const entries = useCredentialEntries();
  return (
    <CommonUtilitiesLayout entries={entries}>
      <Routes>
        {entries.map((r) => (
          <Route key={r.path} path={r.path} element={r.element} />
        ))}
      </Routes>
    </CommonUtilitiesLayout>
  );
};
